export const ENVIRONMENT_CONSTANTS = {
	DEV: 'development',
	ENVIRONMENT: '@@APPENV@@',
	APP_REGION: '@@APPREGION@@',
	PROD: 'production'
};
